/** Fill an empty enquiry message without replacing an existing message. */
class VlabReprint extends HTMLElement {
  connectedCallback() {
    const piece = new URL(location.href).searchParams.get('piece')?.trim();
    const message = this.querySelector('textarea[name="contact[body]"]');
    if (!piece || !message || message.value.trim()) return;
    message.value = this.dataset.reprintPrefix + ' ' + piece.slice(0, 500);
    message.dispatchEvent(new Event('input', { bubbles: true }));
  }
}
if (!customElements.get('vlab-reprint')) customElements.define('vlab-reprint', VlabReprint);
